module.exports = __webpack_public_path__ + "static/media/illustration-pageAtivo-vazio.4292b9cd.svg";